import React from 'react';
import { Tabs, TabsList, TabsTrigger } from './ui/tabs';

const Navigation = ({ activeTab, onTabChange }) => {
  return (
    <div className="w-full bg-white border-b border-slate-200 sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex items-center justify-between">
          {/* Left Tab */}
          <div className="flex-1">
            <Tabs value={activeTab} onValueChange={onTabChange} className="w-fit">
              <TabsList className="grid w-full grid-cols-2 bg-slate-100 p-1 h-auto">
                <TabsTrigger 
                  value="calculator" 
                  className="data-[state=active]:bg-white data-[state=active]:text-slate-900 text-slate-600 font-medium px-6 py-3 h-auto rounded-md transition-all"
                >
                  Calculator
                </TabsTrigger>
                <TabsTrigger 
                  value="warmup" 
                  className="data-[state=active]:bg-white data-[state=active]:text-slate-900 text-slate-600 font-medium px-6 py-3 h-auto rounded-md transition-all"
                >
                  WarmUp
                </TabsTrigger>
              </TabsList>
            </Tabs>
          </div>
          
          {/* Center Logo */}
          <div className="flex-1 flex justify-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_pricing-calculator-1/artifacts/hbl9wyzl_logo-oc.png" 
              alt="One Control Logo" 
              className="h-12 w-auto object-contain"
            />
          </div>
          
          {/* Right Space (for balance) */}
          <div className="flex-1"></div>
        </div>
      </div>
    </div>
  );
};

export default Navigation;